function CampaignWizardSelectTemplateController(
    $scope,
    $q,
    $filter,
    PermissionService,
    CampaignsService,
    ErrorService,
    $state,
    LocalisationService,
    $interpolate,
    CampaignDesignerService,
    CampaignWizardService,
    NgTableParams) {

    var self = this;

    self.initialise = function () {
        self.userContext = PermissionService.userContext;
        $scope.localisationService = LocalisationService;
        self.campaigns = [];
        self.campaignsForSelectedObjective = [];
        $scope.interpolate = $interpolate;
        $scope.campaignsForSelectedObjective = [];
        $scope.showVoucherCampaigns = true;
        $scope.showPushCampaigns = true;
        $scope.showMenuscriptCampaigns = true;
        $scope.showSMSCampaigns = true;
        $scope.searchText = "";

        /**
         * communication card labels lookup
         */
        $scope.communicationCardLabels = {
            New: 1,
            Expiring: 2,
            SMS: 3,
            PushNotification: 4,
            Voucher: 5,
            MenuScript: 6
        };


        if (!self.userContext) {
            return;
        }

        $scope.contextName = self.userContext.getCurrentContextName();
        CampaignWizardService.Campaign = null;
        checkUserAccessToCampaignManagement();
        loadCampaigns();
        setupTable();
    };

    var navigateToCampaign = function (id) {
        $state.go('.customise', {
            storeId: $state.params.storeId,
            brandId: $state.params.brandId,
            CampaignTemplateId: id
        });
    }

    var addTooltip = function () {
        $(".truncate").each(function () {
            var thisTxt = $(this).text();
            var cloneEle = document.createElement("div");
            cloneEle = $(cloneEle);
            cloneEle.addClass("ele-clone");
            cloneEle.html(thisTxt);
            $("body").append(cloneEle);
            if ($(this).width() <= cloneEle.width()) {
                $(this).attr("title", thisTxt);
                $(this).tooltip();
            } else {
                $(this).removeAttr("title");
            }
            cloneEle.remove();
        });
    };

    $scope.availableCampaignTypes = {
        SMS: false,
        PushNotification: false,
        Voucher: false,
        MenuScript: false
    };

    var checkUserAccessToCampaignManagement = function () {
        var userCanManageCampaigns = PermissionService
            .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.ManageCampaigns,
                self.userContext);

        if (!userCanManageCampaigns) {
            PermissionService.navigateToAccessDenied();
        }
    };

    var setupTable = function () {

        $scope.campaignsTableParams = new NgTableParams({
            page: 1,
            count: Dashboard.NgTableParams.InitialCount
        }, {
            counts: self.counts,
            getData: function (params) {
                return Dashboard.helpers.tableHelper
                    .sortAndFilter(params, $filter, self.campaignsForSelectedObjective);
            }
        });
    };

    var loadCampaignObjectives = function () {
        var objectives = _.map(self.campaigns, function (campaign) {
            return campaign.CampaignObjectives;
        });
        var flat = _.flatten(objectives);
        var uniqueObjectives = findUniqueObjectives(flat);
        var defaultObjectiveOption = {
            Id: 0,
            Name: "All Categories"
        };
        $scope.ObjectiveOptions = uniqueObjectives;
        $scope.ObjectiveOptions.unshift(defaultObjectiveOption);
        $scope.selectedObjective = defaultObjectiveOption;
    };

    /**
     * Because _.unique doesn't work
     * @param objectives
     */
    var findUniqueObjectives = function (objectives) {
        var filteredObjectives = [];
        for (var i = 0; i < objectives.length; i++) {
            var objective = objectives[i];
            var captured = _.some(filteredObjectives, function (obj) {
                return objective.Id === obj.Id;
            });
            if (!captured) {
                filteredObjectives.push(objective);
            }
        }
        return filteredObjectives;
    };


    var loadCampaigns = function () {
        $scope.$root.isLoading = true;
        $q.all(
            [
                CampaignsService.getPublishedCampaigns(self.userContext.StoreId, self.userContext.BrandId),
                CampaignsService.getFavouriteCampaigns(self.userContext.StoreId, self.userContext.BrandId)
            ]).then(function (results) {
            self.campaigns = _.map(results[0].data.Campaigns, function (item) {
                var campaign = new Dashboard.Models.Campaign().initialiseCampaign(item, $scope.localisationService);
                campaign.setIsNewFlag();
                campaign.IsFavourite = _.some(results[1].data.Campaigns, function (item) {
                    return campaign.Id === item;
                });
                campaign.setSortableByNewestOrFavourite();
                return campaign;
            });
            loadCampaignObjectives();
            $scope.filterCampaigns();
            $scope.setAvailableCampaignTypes();
        }).finally(function () {
            $scope.$root.isLoading = false;
            setTimeout(addTooltip);
            setTimeout(function () {
                if ($state.params.CampaignTemplateId) {
                    navigateToCampaign($state.params.CampaignTemplateId);
                }
            });
        });
    };

    /**
     * Sets the visibility of the filters
     */
    $scope.showFilters = function () {
        var availableCampaignTypesProperties = Object.getOwnPropertyNames($scope.availableCampaignTypes);

        var filterCount = _.reduce(availableCampaignTypesProperties, function (acc, cur) {
            return acc + ($scope.availableCampaignTypes[cur] ? 1 : 0);
        }, 0);
        return self.campaigns.length > 5 && filterCount > 1;
    };

    /**
     * Counts the campaign types
     */
    $scope.setAvailableCampaignTypes = function () {
        var SMSCampaigns = _.filter(self.campaigns, function (campaign) {
            return campaign.HasSMS();
        });

        var pushNotificationCampaigns = _.filter(self.campaigns, function (campaign) {
            return campaign.HasPush();
        });

        var voucherCampaigns = _.filter(self.campaigns, function (campaign) {
            return campaign.HasVoucher();
        });

        var menuScriptCampaigns = _.filter(self.campaigns, function (campaign) {
            return campaign.HasMenuscript();
        });

        $scope.availableCampaignTypes.SMS = SMSCampaigns.length > 0;
        $scope.availableCampaignTypes.PushNotification = pushNotificationCampaigns.length > 0;
        $scope.availableCampaignTypes.Voucher = voucherCampaigns.length > 0;
        $scope.availableCampaignTypes.MenuScript = menuScriptCampaigns.length > 0;
    };

    /**
     * Filters the campaigns
     */
    $scope.filterCampaigns = function () {
        var filteredCampaigns = _.filter(self.campaigns, function (campaign) {
            var showSMS = campaign.HasSMS() && $scope.showSMSCampaigns;
            var showPushNotification = campaign.HasPush() && $scope.showPushCampaigns;
            var showVoucher = campaign.HasVoucher() && $scope.showVoucherCampaigns;
            var showMenuScript = campaign.HasMenuscript() && $scope.showMenuscriptCampaigns;
            var matchesText = !$scope.searchText
                || $scope.searchText.length === 0
                || campaign.NameOrDescriptionContains($scope.searchText);
            return (showSMS
                || showPushNotification
                || showVoucher
                || showMenuScript)
                && matchesText;
        });
        setCampaignsForSelectedObjective(filteredCampaigns);
    };

    var setCampaignsForSelectedObjective = function (campaigns) {
        var filteredCampaigns = _.filter(campaigns, function (campaign) {
            if ($scope.selectedObjective.Id === 0) return true;
            return _.some(campaign.CampaignObjectives, function (objective) {
                return objective.Id === $scope.selectedObjective.Id;
            })
        });
        self.campaignsForSelectedObjective = _.map(filteredCampaigns, function (campaign) {
            return setCategoryToCampaignForSelectedObjective(campaign, $scope.selectedObjective.Id);
        });
        Dashboard.helpers
            .tableHelper
            .reloadTable($scope.campaignsTableParams,
                self.campaignsForSelectedObjective);
    };

    var setCategoryToCampaignForSelectedObjective = function (campaign, objectiveId) {
        var category = _.find(campaign.CampaignObjectives, function (objective) {
            return objective.Id === objectiveId;
        });
        var displayedName;
        if (!category) {
            var categoryNames = _.map(campaign.CampaignObjectives, function (objective) {
                return objective.Name;
            });
            displayedName = categoryNames.join(', ');
        } else {
            displayedName = category.Name;
        }
        var containsDisplayName = displayedName && displayedName.length > 0;
        campaign.Category = containsDisplayName
            ? displayedName
            : 'Uncategorised';
        return campaign;
    };

    /**
     * Navigate to the campaign that was selected
     * @param campaignId {number}
     */
    $scope.selectCampaign = function (campaignId) {
        navigateToCampaign(campaignId);
    };

    /**
     * Loads the published campaigns for the current user/store
     */

    self.initialise();
}

angular
    .module('dashboard')
    .component('campaignWizardSelectTemplate',
        {
            templateUrl: 'components/campaigns/wizard/step-1/campaign-wizard-select-template.b2ccfe64.html',
            controller: [
                '$scope',
                '$q',
                '$filter',
                'PermissionService',
                'CampaignsService',
                'ErrorService',
                '$state',
                'LocalisationService',
                '$interpolate',
                'CampaignDesignerService',
                'CampaignWizardService',
                'NgTableParams',
                CampaignWizardSelectTemplateController]
        });
